"use client";

import SubpageBackground from "@/components/common/SubpageBackground";

export default function CookiesLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative min-h-screen flex flex-col bg-background pb-16 sm:pb-[120px]">
      {/* Background Image */}
      <SubpageBackground />

      <div className="relative z-10 flex flex-col flex-1">
        <main className="flex-1 w-full px-4 sm:px-6 lg:px-8">{children}</main>
      </div>
    </div>
  );
}
